import React from "react";
import { Flex, HStack, Text, Button, Icon } from "@chakra-ui/react";
import { BsStars } from "react-icons/bs";

/**
 * AgendaHeader - Header section with title and Smart Agenda button
 * Used at the top of the agenda homepage
 */
const AgendaHeader = ({
  title = "Agenda Home",
  buttonText = "New Smart Agenda",
  onSmartAgendaClick,
  isLoading = false,
  disabled = false,
  showSparkles = false,
  ...props
}) => {
  return (
    <Flex justify="space-between" align="center" w="100%" gap="23px" {...props}>
      <HStack spacing="5px" align="center">
        {showSparkles && (
          <Icon as={BsStars} w="20px" h="20px" color="#4C47CC" />
        )}
        <Text
          fontSize="sm"
          fontWeight="400"
          color="#0C001C"
          lineHeight="1.5"
          letterSpacing="-2%"
          fontFamily="Geist, sans-serif"
        >
          {title}
        </Text>
      </HStack>

      {buttonText && (
        <Button
          bg="#4C47CC"
          color="white"
          fontSize="13px"
          fontWeight="700"
          lineHeight="1.231"
          fontFamily="Geist, sans-serif"
          borderRadius="8px"
          px="8px"
          py="8px"
          h="auto"
          minH="auto"
          isLoading={isLoading}
          disabled={disabled}
          transition="all 0.2s"
          onClick={onSmartAgendaClick}
          leftIcon={<Icon as={BsStars} w="16px" h="16px" />}
          iconSpacing="6px"
          _hover={{ bg: "#3A37B3", transform: "translateY(-1px)" }}
          _active={{ transform: "translateY(0px)" }}
          _disabled={{
            bg: "#B8B2C0",
            cursor: "not-allowed",
            transform: "none",
          }}
          data-testid="smart-agenda-button"
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};

export default AgendaHeader;
